module.exports = __webpack_public_path__ + "static/media/rewardsLogo.2af74918.svg";